// extracted by mini-css-extract-plugin
module.exports = {"button":"button--5b2f7"};